export const SET_THEME = 'SET_THEME';
export const SET_TITLE = 'SET_TITLE';
export const SET_LOGO = 'SET_LOGO';
export const SET_FAVICON = 'SET_FAVICON';
export const SET_URL_PLATAFORM = 'SET_URL_PLATAFORM';
export const SET_ORGANIZATION_NAME = 'SET_ORGANIZATION_NAME';
export const SET_URL_WHATSAPP = 'SET_URL_WHATSAPP';
export const SET_SHOW_PRICING = 'SET_SHOW_PRICING';